import * as React from 'react';
import * as agui from 'arm-gui/dist/controls';
import { Utils, DateFormatter, domain, UiUtils, i18n, isAuth, NumberFormatter } from 'arm-common';
import { isNullOrUndefined } from 'util';


class BtnDelete extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[BtnDelete.jsx] ";
    }

    render() {
        console.log(this.componentName + " render");
        let className = "float-left";

        if (!isNullOrUndefined(this.props.className)) {
            className = this.props.className;
        }

        return (
            <agui.aButton bs="danger" className={className} icon="fas fa-trash-alt" onClick={this.props.onClick} >
                {i18n("ARM_CORE_PRODUCT.SHARED.ELIMINA", "Elimina")}
            </agui.aButton>
        );
    }
}

export default BtnDelete;